(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodSearchInput', sodSearchInput);

    function sodSearchInput() {
        return {
            restrict: 'E',
            scope: { config: '=' },
            transclude: true,
            templateUrl: 'common/components/sod-search-input',
            controller: sodSearchInputCtrl,
            controllerAs: 'vm',
            bindToController: true,
            compile: sodSearchInputCompile,
            link: sodSearchInputLink,
        };

        function sodSearchInputCompile(tElement, attrs, transclude) {
            return function ($scope) {
                transclude($scope, function (clone) {
                    tElement.append(clone);
                });
            };

        }

        function sodSearchInputLink(scope, elem, attr) {
        }
    }

    function sodSearchInputCtrl(lodash, $element, $scope, FilterFactory, GroupFilterFactory, $httpParamSerializer) {
        var vm = this;
        var filterPath = '';
        this.$onInit = function() {
            vm.groupFilterFactory = GroupFilterFactory(lodash.get(vm, 'config.grid_id', null));
            filterPath = [lodash.get(vm, 'config.grid_id', ''), lodash.get(vm, 'config.type', '')].join('.');

            vm.apply = apply;
            vm.directSearch = directSearch;
            vm.handleModelChange = handleModelChange;
            vm.model = getFilterModel(init);

            init();
        }



        function apply() {
            applyFilter();
        }

        function getSearchUrl() {
            var filters = getAllFilters();
            vm.searchUrl = ['portal/jobs', '?', $httpParamSerializer({ filter: filters })].join('');
        }

        function getAllFilters() {
            return FilterFactory.get(lodash.get(vm, 'config.grid_id', ''));
        }

        function getFilterModel(init) {
            var filterValue = FilterFactory.get(filterPath, init ? lodash.get(vm, 'config.active_filters', {}) : {});
            return lodash.get(filterValue, 0, '').toString();
        }

        function setFilterModel() {
            FilterFactory.set(filterPath, [vm.model]);
        }

        function handleModelChange() {
            setFilterModel();
        }

        function applyFilter() {
            vm.groupFilterFactory.applyFilter(lodash.get(vm, 'config.grid_id', null));
        }
        
        function directSearch() {
            getSearchUrl();
        }

        function init() {
            var filtersChangeListener = $scope.$on(
                [FilterFactory.eventPrefix, filterPath].join('.'),
                function (e) {
                    vm.model = getFilterModel();

                    var category = lodash.get(vm, 'config.category', null);
                    if (category === 'direct-search') {
                        directSearch();
                    }
                }
            );

            $scope.$on('$destroy', function () {
                filtersChangeListener();
            });
        }
    }
})();